import React, { Fragment, PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import cx from 'classnames';
import { isNullOrUndefined } from '../../utils/objects';
import { joinDefined } from '../../utils/strings';
import Tooltip from '../form/Tooltip';
import NavigationItems from '../../views/NavigationItems';

class DrawerListItem extends PureComponent {
    state = {
        expanded: false
    };

    componentDidMount() {
        const { activeItem, item } = this.props;
        if (isActive(item, activeItem)) this.setState({ expanded: true });
        else if (!!item.expanded) this.setState({ expanded: true });
    }

    onClick = e => {
        const { onNav, item } = this.props;

        if (item.path) {
            if (item.newTab) {
                let win = window.open(item.path, '_blank');
                win.focus();
            } else {
                onNav(item.path);
            }
        } else if (item.items) {
            const expanded = !this.state.expanded;
            this.setState({ expanded });
        }
    };

    onExpand = e => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        this.setState({ expanded: !this.state.expanded });
    };

    render() {
        const { item, activeItem, nested, hidden, minimized, renderItem, renderGroup } = this.props;

        let renderFunc;
        if (item.items && renderGroup) renderFunc = renderGroup;
        else if (!item.items && renderItem) renderFunc = renderItem;

        const classNames = `drawer-list-item ${joinDefined(
            [
                isActive(item, activeItem) ? 'drawer-list-item--active' : null,
                nested ? 'drawer-list-item--nested' : null,
                minimized ? 'drawer-list-item--minimized' : null
            ],
            ' '
        )}`;

        return (
            <Fragment>
                <ListItem
                    button
                    onClick={this.onClick}
                    className={classNames}
                    aria-hidden={hidden}
                    tabIndex={hidden ? -1 : 0}
                >
                    {item.icon && this.renderIcon()}
                    {renderFunc ? renderFunc(item) : this.renderText()}
                    {this.renderAction()}
                </ListItem>
                {this.renderChildItems()}
            </Fragment>
        );
    }

    renderIcon() {
        const { item, activeItem } = this.props;
        return (
            <Tooltip title={item.label}>
                <ListItemIcon>
                    <item.icon className={cx('icon', { 'icon--active': item === activeItem })} />
                </ListItemIcon>
            </Tooltip>
        );
    }

    renderText() {
        const { item, activeItem } = this.props;
        return (
            <ListItemText
                primary={item.label}
                classes={{
                    primary: cx('text', item.newTab && 'targetNewPage', {
                        'text--active': item === activeItem
                    })
                }}
            />
        );
    }

    renderAction() {
        const { item, minimized } = this.props;
        if (minimized || !item.items) return;
        const { expanded } = this.state;
        return (
            <IconButton onClick={this.onExpand} size="large">{expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</IconButton>
        );
    }

    renderChildItems() {
        const { item, minimized, activeItem } = this.props;
        if (!item.items) return;
        const { expanded } = this.state;
        const activePath = activeItem && activeItem.path ? activeItem.path : '';
        const itemPath = item && item.path ? item.path : '';
        let inPath = activePath.startsWith(itemPath);
        if ('/' === itemPath) {
            const homeItems = NavigationItems.find(obj => '/' === obj.path);
            inPath = activePath === itemPath || !!homeItems.items.find(obj => activePath === obj.path);
        }
        return (
            <Collapse in={minimized ? inPath : expanded}>
                <List component="div" disablePadding style={{ zoom: minimized ? 0.75 : null }}>
                    {item.items.map(this.renderChildItem)}
                </List>
            </Collapse>
        );
    }

    renderChildItem = item => {
        const { minimized, activeItem, hidden, renderItem, renderGroup, onNav } = this.props;
        const { expanded } = this.state;
        return (
            <DrawerListItemConnected
                key={item.id || item.label}
                item={item}
                nested
                onNav={onNav}
                minimized={minimized}
                activeItem={activeItem}
                hidden={hidden || !expanded}
                renderItem={renderItem}
                renderGroup={renderGroup}
            />
        );
    };

}

const isActive = (self, activeItem) => {
    if (self === activeItem) return true;

    if (isNullOrUndefined(self.items)) return false;

    return !isNullOrUndefined(self.items.find(x => x === activeItem));
};

const DrawerListItemConnected = withStyles({})(DrawerListItem);
export default DrawerListItemConnected;
